import PropTypes from "prop-types";
import { useSelector, shallowEqual } from "react-redux";
import { resolutionPropType } from "app/utils/propTypes";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import { useLocation, useParams } from "react-router-dom";
import { checkSpecialOfferForSelectedDepartureDate } from "app/pages/Booking/Payment/paymentSelector";
import SpecialOffer from "app/pages/.shared/SpecialOffer/SpecialOffer";
import { isUserMatchWithType } from "app/utils/utils";
import { matchesDestinationFilter } from "app/utils/destinationFilterUtils";
import { isAuthenticated } from "app/pages/Auth/authSelectors";

const mapStateToProps = state => {
	return {
		specialOffer: state.ficheProduit.specialOffer,
		fallBackSpecialOffer: state.partner.fallbackSpecialOffer,
		isSpecialOfferActive: checkSpecialOfferForSelectedDepartureDate(state),
		resolution: state.resolution,
		userIsConnected: isAuthenticated(state),
		searchedDestinationLabel: state.booking?.destinationResort?.label,
		productCountry: state.ficheProduit?.country,
		productResort: state.ficheProduit?.resort,
	};
};

const SearchEngineMessagePlaceholderContainer = () => {
	const {
		specialOffer = {},
		fallBackSpecialOffer = {},
		isSpecialOfferActive,
		resolution,
		userIsConnected,
		searchedDestinationLabel,
		productCountry,
		productResort,
	} = useSelector(mapStateToProps, shallowEqual);
	const currentDestinationLabels = [searchedDestinationLabel, productCountry, productResort];
	const location = useLocation();
	const isBookingSearchPage = location?.pathname?.includes("/booking/search");
	const { productUri } = useParams();

	let spo = undefined;

	const usersFilterType = specialOffer?.ui?.usersFilter;
	const checkUserType = isUserMatchWithType(usersFilterType, userIsConnected);

	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;
	if (!isMobile) {
		const isProductPage = Boolean(productUri);
		const shouldDisplaySpecialOfferOnCurrentPage =
			checkUserType &&
			isSpecialOfferActive &&
			specialOffer.pages &&
			specialOffer.pages.find(page => {
				return location.pathname.includes(page) || (page === "product" && isProductPage);
			}) &&
			matchesDestinationFilter(specialOffer.destinations, currentDestinationLabels);

		const shouldDisplaySpecialOfferFallbackOnCurrentPage =
			checkUserType &&
			fallBackSpecialOffer.pages &&
			fallBackSpecialOffer.pages.find(page => {
				return location.pathname.includes(page) || (page === "product" && isProductPage);
			}) &&
			matchesDestinationFilter(fallBackSpecialOffer.destinations, currentDestinationLabels);

		if (shouldDisplaySpecialOfferOnCurrentPage) {
			spo = specialOffer;
		} else if (shouldDisplaySpecialOfferFallbackOnCurrentPage) {
			spo = fallBackSpecialOffer;
		}
	}
	const shouldDisableFlexSpecialOffer = spo?.code === "FLEX";
	if (shouldDisableFlexSpecialOffer) {
		return null;
	}

	// specialOffer.ui.background n'est pas passé à SpecialOffer pour ne pas avoir un block trop voyant ici
	return spo && !isBookingSearchPage ? (
		<div className="booking-marketing-placeholder">
			<div className="search-engine-message-placeholder">
				<SpecialOffer
					type={spo.type}
					title={spo.title}
					message={spo.summary}
					background={spo?.ui?.background}
					titleColor={spo?.ui?.titleColor}
					textColor={spo?.ui?.textColor}
					pictoUrl={spo?.ui?.pictoUrl}
					tooltipMessage={spo.details}
				/>
			</div>
		</div>
	) : null;
};

SearchEngineMessagePlaceholderContainer.propTypes = {
	resolution: resolutionPropType,
	isSpecialOfferActive: PropTypes.bool,
	specialOffer: PropTypes.object,
	fallBackSpecialOffer: PropTypes.object,
	userIsConnected: PropTypes.bool,
	searchedDestinationLabel: PropTypes.string,
	productCountry: PropTypes.string,
	productResort: PropTypes.string,
};

export default SearchEngineMessagePlaceholderContainer;
